// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRentPaymentWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CappsGetRenterRequestPaymentApplicationApiRequestDto,
  CappsGetRenterRequestPaymentApplicationApiResponseDto,
  CappsOptInRenterRequestPaymentApplicationApiRequestDto,
  CappsOptInRenterRequestPaymentApplicationApiResponseDto,
  CappsOptOutRenterRequestPaymentApplicationApiRequestDto,
  CappsOptOutRenterRequestPaymentApplicationApiResponseDto,
} from '../..';

export const CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_Path =
  '/api/web/renter/v1/rentPayment/getRenterRequestPaymentApplication';

export const CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication = (
  postData: CappsGetRenterRequestPaymentApplicationApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    CappsGetRenterRequestPaymentApplicationApiRequestDto,
    CappsGetRenterRequestPaymentApplicationApiResponseDto
  >(
    {
      endpoint: CappsRentPaymentWebApiHandler_getRenterRequestPaymentApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication_Path =
  '/api/web/renter/v1/rentPayment/optInRenterRequestPaymentApplication';

export const CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication = (
  postData: CappsOptInRenterRequestPaymentApplicationApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    CappsOptInRenterRequestPaymentApplicationApiRequestDto,
    CappsOptInRenterRequestPaymentApplicationApiResponseDto
  >(
    {
      endpoint: CappsRentPaymentWebApiHandler_optInRenterRequestPaymentApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication_Path =
  '/api/web/renter/v1/rentPayment/optOutRenterRequestPaymentApplication';

export const CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication = (
  postData: CappsOptOutRenterRequestPaymentApplicationApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    CappsOptOutRenterRequestPaymentApplicationApiRequestDto,
    CappsOptOutRenterRequestPaymentApplicationApiResponseDto
  >(
    {
      endpoint: CappsRentPaymentWebApiHandler_optOutRenterRequestPaymentApplication_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
